<template>
  <div class="quotes-table">
    <b-table class="custom-table"
             borderless
             responsive
             :fields="fields"
             :items="quotes"
             :tbody-tr-class="getRowClass">
      <template v-slot:cell(details)="row">
        <button class="btn btn-sm btn-accent-1"
                @click="row.toggleDetails">
          {{ row.detailsShowing ? 'Hide' : 'View' }}
        </button>
      </template>
      <template v-slot:row-details="row">
        <div class="quotes-table__card">
          <div class="quotes-table__card-header">
            Products
          </div>

          <p>
            {{ row.item.externalNotes }}
          </p>

          <div v-for="(item, index) in row.item.sopLines"
               :key="index"
               class="quotes-table__card-line">
            <div class="row no-padding">
              <div class="col flex-grow-1 no-padding">
                {{ item.productDisplayName }} x{{ item.quantity }}
              </div>
              <div class="col flex-grow-0 no-padding">
                <b>
                  {{ formatPrice(item.priceExcVat) }}
                </b>
              </div>
            </div>
          </div>

          <div v-if="row.item.statusId === 'ACT'"
               class="quotes-table__card-footer">
            <button
              class="btn btn-sm btn-accent-1"
              @click="showConvertModal( row.item.id )">
              Convert to basket
            </button>
          </div>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import { format } from "date-fns";
import { EcommerceModule } from "spiritweb.packages.ecommerce";

export default {
  name: "QuotesTable",
  props: {
    quotes: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      fields: [
        {
          key: "reference",
          label: "Quote ref"
        },
        {
          key: "date",
          label: "Date raised",
          formatter: this.formatDate
        },
        {
          key: "salesPerson",
          label: "Raised by"
        },
        {
          key: "person",
          label: "Raised on behalf of"
        },
        {
          key: "sopLines",
          label: "Items in quote",
          formatter: this.formatItems
        },
        {
          key: "totalExcludingVat",
          label: "Total ex vat",
          formatter: this.formatPrice
        },
        {
          key: "totalIncludingVat",
          label: "Total inc vat",
          formatter: this.formatPrice
        },
        {
          key: "details",
          label: ""
        }
      ]
    };
  },
  methods: {
    getRowClass ( item ) {
      let result = "";

      if ( item.statusId !== "ACT" ) {
        result = "inactive";
      }

      return result;
    },
    formatDate ( input ) {
      return format( new Date( input ), "dd/MM/yyyy" );
    },
    formatItems ( input ) {
      let result = "";

      if ( input && input.length > 0 ) {
        result += `${input.length} item${input.length !== 1 ? "s" : ""}: `;
        result += input.map( x => x.productDisplayName?.trim() ).join( ", " );
      }

      if ( result.length > 45 ) {
        result = `${result.substring( 0, 45 )}...`;
      }

      return result;
    },
    formatPrice ( input ) {
      return EcommerceModule.renderPrice( input, "gbp", "en-gb" );
    },
    showConvertModal ( quoteId ) {
      this.$emit( "show-convert-modal", quoteId );
    }
  }
};
</script>

<style lang="less">
.quotes-table {
  background-color: #fff;

  &__card {
    border: 2px solid #B2D6D9;
    background-color: #fff;
    padding: 10px;

    &-header {
      font-size: 1.2rem;
      font-weight: 600;
    }

    &-line {
      padding: 5px;
      &:not( :last-child ) {
        border-bottom: 1px solid #B2D6D9;
      }
    }

    &-footer {
      padding-top: 10px;
    }
  }

  .no-padding {
    margin: 0 !important;
    padding: 0 !important;
  }

  .inactive {
    background: #f2f2f2;
  }
}
</style>
